<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col><div class="text-h6 white--text">Preparando</div></v-col>
    </v-row>
    <v-skeleton-loader
      type="paragraph"
      :loading="!dataLoaded">
      <v-list class="no-padding" color="contrast">
        <div v-if="filteredOrders.length > 0">
          <v-list-item
            class="no-padding"
            v-for="order in filteredOrders"
            :key="order.id">
            <v-col cols="12" class="no-padding-sites">
              <v-card outlined>
                <v-card-text @click="handleClick(order)">
                  <v-container fluid>
                    <v-row no-gutters align="center" justify="center" v-if="order.downloaded">
                      <v-col><div class="text-h6" v-text="order.increment_id"></div></v-col>
                      <v-col>
                        <div class="text-h6 text-capitalize" v-text="`${order.customer_firstname} ${order.customer_lastname}`"></div>
                      </v-col>
                      <v-col align="center">
                        <div class="text-h6 text-capitalize" v-text="getPrettyShipping(order.shipping_method)"></div>
                        <div v-if="order.has_instructions">
                          <v-icon>mdi-message-bulleted</v-icon>
                        </div>
                      </v-col>
                      <v-col align="center"><div class="text-h6 text--disabled" v-text="$moment(order.created_at).format('hh:mm a')"></div></v-col>
                      <v-divider vertical></v-divider>
                      <v-col align="center" @click.prevent.stop="moveOrder(order)">
                        <v-btn icon>
                            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center" justify="center" v-else-if="order.inconsistent">
                      <v-col cols="2"><div class="text-h6" v-text="order.id"></div></v-col>
                      <v-col cols="8" align="center">
                        <v-chip style="width: 90%;" color="orange" label text-color="white" class="justify-center">
                          <div
                            class="text-subtitle-1 font-weight-bold"
                            v-text="getPrettyInconsistency(order.Status)">
                          </div>
                        </v-chip>
                        <div class="text-h6" v-text="'Ocurrió un error, favor de verificar ésta orden.'"></div>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col align="center">
                        <v-btn icon>
                            <v-icon>mdi-alert-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center" justify="center" v-else>
                      <v-col cols="3"><div class="text-h6" v-text="order.id"></div></v-col>
                      <v-col cols="7">
                        <div class="text-h6" v-text="'Ocurrió un error al descargar la información'"></div>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col align="center">
                        <v-btn icon>
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-list-item>
        </div>
        <v-list-item
          v-else
          class="no-padding">
            <v-col cols="12" class="no-padding-sites">
              <v-card outlined>
                <v-card-text>
                  <v-container fluid>
                    <v-row no-gutters>
                      <v-col align="center"><div class="text-h6" v-text="'Sin órdenes por el momento'"></div></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
        </v-list-item>
      </v-list>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
  import mixins from '../helpers/mixins';

  export default {
    name: 'PreparingOrdersList',
    mixins: [mixins],
    props: {
      orders: {
        default: () => {},
        type: Object
      },
      dataLoaded: {
        default: () => false,
        type: Boolean
      },
      filterBy: {
        default: () => null,
        type: String
      },
    },
    computed: {
      filteredOrders() {
        const filtered = [];
        Object.keys(this.orders).map((orderId) => {
          const order = this.orders[orderId];
          if (this.filterBy != null) {
            if (this.filterBy == this.getPrettyShipping(order.shipping_method) || order.inconsistent) {
              filtered.push(order);
            }
          } else {
            filtered.push(order);
          }
        });

        return filtered;
      }
    },
    data: () => ({}),
    methods: {
      handleClick(order) {
        if (order.downloaded) {
          this.showDetails(order.entity_id, order.increment_id, true);
        } else if (order.inconsistent) {
          this.verifyOrder();
        } else {
          this.getOrderData(order.id);
        }
      },
      showDetails(orderId, orderIncrementId, showAction) {
        this.$router.push({ name: 'order', params: { orderId, orderIncrementId, showAction } });
      },
      getOrderData(orderId) {
        this.$swal.fire({
          title: 'Reintentando descarga',
          html: 'Espere...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading();
            const orders = [ orderId ];

            this.downloadOrdersCall(orders)
              .then((result) => {
                if (result.code == 200) {
                  this.handleOrdersResponse(orders, result.result, true);
                } else {
                  this.handleOrdersResponse(orders, [], false);
                }
              })
              .catch(() => {
                this.handleOrdersResponse(orders, [], false);
              });
          }
        });
      },
      handleOrdersResponse(orders, responseOrders, isSuccess) {
        orders.map((orderId) => {
          if (isSuccess) {
            const arrayExists = responseOrders.filter((order) => {
              return order.entity_id == orderId;
            });

            let order = {};
            if (arrayExists.length > 0) {
              order = arrayExists[0];
              order.status = this.$store.state.status[1];
              order.downloaded = true;
            } else {
              order = {
                id: orderId,
                status: this.$store.state.status[1],
                downloaded: false
              };
            }

            this.$store
              .dispatch('updateDownloadedOrder', {
                id: orderId,
                order
              }).then(() => {
                this.$swal.close();
              });
          } else {
            this.$store
              .dispatch('updateDownloadedOrder', {
                id: orderId,
                order: {
                  id: orderId,
                  status: this.$store.state.status[1],
                  downloaded: false
                }
              })
              .then(() => {
                this.$swal.close();
              });
          }
        });
      },
      verifyOrder() {
      },
      async downloadOrdersCall(ids) {
        const params = {
          ids
        };

        return await this.$magentoAxios.get('newOrders/', params);
      },
    }
  }
</script>

<style scoped>
  .no-padding {
    padding: 0px !important;
  }
  .no-padding-sites {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
</style>